<script>
    import { t } from '../i18n'
</script>

<div class="flex justify-center items-center h-screen">
    <div class="text-center">
        <img src="img/datajalostamo-blue.png" alt="{$t('general.datajalostamo-logo-alt')}" class="w-96 mb-4">
        <div class="flex justify-center mb-6">
            <div class="dot-bricks" />
        </div>
        <p class="text-grey-700">{$t('general.loading-info')}</p>
    </div>
</div>

<style>
    .dot-bricks {
        position: relative;
        top: 8px;
        left: -9999px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: theme('colors.primary-blue');
        color: theme('colors.primary-blue');
        box-shadow: 9991px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue');
        animation: dotBricks 2s infinite ease;
    }

    @keyframes dotBricks {
        0% {
            box-shadow: 9991px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue');
        }
        8.333% {
            box-shadow: 10007px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue');
        }
        16.667% {
            box-shadow: 10007px -16px 0 0 theme('colors.primary-blue'), 9991px -16px 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue');
        }
        25% {
            box-shadow: 10007px -16px 0 0 theme('colors.primary-blue'), 9991px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue');
        }
        33.333% {
            box-shadow: 10007px 0 0 0 theme('colors.primary-blue'), 9991px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue');
        }
        41.667% {
            box-shadow: 10007px 0 0 0 theme('colors.primary-blue'), 10007px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue');
        }
        50% {
            box-shadow: 10007px 0 0 0 theme('colors.primary-blue'), 10007px -16px 0 0 theme('colors.primary-blue'), 9991px -16px 0 0 theme('colors.primary-blue');
        }
        58.333% {
            box-shadow: 9991px 0 0 0 theme('colors.primary-blue'), 10007px -16px 0 0 theme('colors.primary-blue'), 9991px -16px 0 0 theme('colors.primary-blue');
        }
        66.666% {
            box-shadow: 9991px 0 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue'), 9991px -16px 0 0 theme('colors.primary-blue');
        }
        75% {
            box-shadow: 9991px 0 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue'), 10007px -16px 0 0 theme('colors.primary-blue');
        }
        83.333% {
            box-shadow: 9991px -16px 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue'), 10007px -16px 0 0 theme('colors.primary-blue');
        }
        91.667% {
            box-shadow: 9991px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue'), 10007px -16px 0 0 theme('colors.primary-blue');
        }
        100% {
            box-shadow: 9991px -16px 0 0 theme('colors.primary-blue'), 9991px 0 0 0 theme('colors.primary-blue'), 10007px 0 0 0 theme('colors.primary-blue');
        }
    }
</style>